import React, { useState, useEffect } from "react";
import { Delete, LinkedIn, RemoveRedEye, Search } from "@material-ui/icons";
import {
  Avatar,
  Chip,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  makeStyles,
  useMediaQuery,
  TextField
} from "@material-ui/core";
import "./candidattable.css";
import MUIDataTable from "mui-datatables";
import CustomToolbarSelect from "./CustomToolbarSelect";
import { Box } from "@material-ui/core";
import { useHistory, Link } from "react-router-dom";
import { getUserData, getSenioriteFromDate, getRowData } from "../../../../utils/FunctionHelpers";
import { FiArchive } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { SetSelectedCandidatBeAddToSelection } from "../../../../redux/candidats/actions/candidatsActions";
import { v4 } from "uuid";
import { displaySwipeableDrawerSummaryCandidat } from "../../../../redux/SwipeableDrawer/actions/swipeableDrawerActions";
import { deleteCandidat } from "../../../Services/CandidatService";
import DialogDeleteCustom from "../../../../components/DialogDeleteCustom/DialogDeleteCustom";
import { withSnackbar } from "../../../../utils/SnackbarHOC";
import { handleOnViewColumnsChange, displayColumn } from "../../../../utils/viewColumns";
import { handleChangeRowsPerPage, getRowsPerPage } from "../../../../utils/DataTables";
import moment from "moment";
import ShowAddCvCandidat from "../../VisualiserCandidat/ShowAddCvCandidat";
import { debounce } from "lodash";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
}));

const CandidatTable = ({
  candidatsData,
  handleSearchCandidats,
  parameters,
  snackbarShowMessage,
  aiMode,
  aiRows,
}) => {
  const classes = useStyles();
  const [candidats, setCandidats] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.between(0, 767));
  const isMediumMode = useMediaQuery((theme) =>
    theme.breakpoints.between(767, 1023)
  );
  const [loadToDelete, setLoadToDelete] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [candidatSelectedToDelete, setCandidatSelectedToDelete] =
    useState(null);

  const handleDeleteCandidat = async (uuid) => {
    try {
      setLoadToDelete(true);
      snackbarShowMessage("Patientez svp...", "warning", null);
      const { data } = await deleteCandidat(uuid);
      handleSearchCandidats(candidatsData.pageCandidat, parameters);
      snackbarShowMessage(data);
    } catch (error) {
      snackbarShowMessage("Erreur à la suppression du candidat", "error", 4000);
    } finally {
      setLoadToDelete(false);
      setOpenDialogDelete(false);
    }
  };

  const handlePopoverOpen = (event, index) => {
    setCandidats((prevCandidats) => {
      const newState = prevCandidats.map((candidat, indexC) => {
        if (indexC === index) {
          return { ...candidat, anchorEl: event.currentTarget };
        }
        return candidat;
      });
      return newState;
    });
  };

  const handlePopoverClose = (index) => {
    setCandidats((prevCandidats) => {
      const newState = prevCandidats.map((candidat, indexC) => {
        if (indexC === index) {
          return { ...candidat, anchorEl: null };
        }
        return candidat;
      });
      return newState;
    });
  };

  const handleOpenDialog = (candidat) => {
    setCandidatSelectedToDelete({
      id: candidat.id,
      fullName:
        candidat.fullName.charAt(0).toUpperCase() + candidat.fullName.slice(1),
    });
    setOpenDialogDelete(true);
  };

  const debouncedSearch = debounce((searchText, tableState, parameters, handleSearchCandidats) => {
    handleSearchCandidats(tableState.page + 1, {
      ...parameters,
      column: tableState.sortOrder.name,
      sort: tableState.sortOrder.direction,
      motsCleCategorie: 'tous',
      searchKeys: searchText
    });
  }, 800);

  const PopoverComponent = ({ selections, candidat }) => {
    return (
      <Popover
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={Boolean(candidat.anchorEl)}
        anchorEl={candidat.anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <List>
          {selections?.map((selection) => (
            <ListItem key={v4()} dense={true} disableGutters={true}>
              <ListItemAvatar>
                <Avatar>
                  <FiArchive />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={selection?.nom} />
            </ListItem>
          ))}
        </List>
      </Popover>
    );
  };

  useEffect(() => {
    if (aiMode) {
      if (aiRows?.isLoading) {
        setCandidats([]);
        return;
      }
      setCandidats((aiRows?.data ?? []).map((candidat) => ({ ...candidat, anchorEl: null })));
      return;
    }
    setCandidats((candidatsData.candidats ?? []).map((candidat) => ({ ...candidat, anchorEl: null })));
  }, [aiMode, aiRows, candidatsData.candidats]);


  const tableName = "candidatColumnVisibility";

  const options = {
    rowsPerPageOptions: [30, 50, 75, 100],
    jumpToPage: true,
    tableBodyMaxHeight: "none",
    rowsPerPage: getRowsPerPage(tableName) ?? candidatsData.limit,
    serverSide: !aiMode,
    ...(aiMode
        ? {}
        : {
          page: candidatsData.pageCandidat - 1,
          count: candidatsData.candidatsCount,
        }),
    sortOrder: {
      name: candidatsData.sort.column,
      direction: candidatsData.sort.direction,
    },
    textLabels: {
      body: {
        noMatch: (aiMode ? false : (candidatsData.isLoading || (candidatsData.candidatsCount > 0 && candidats.length === 0))) ? (
          <CircularProgress />
        ) : (
          "Désolé, il n'y a aucun enregistrement dans la base de données pour le moment."
        ),
      },
    },
    onViewColumnsChange: (columnName, action) => {
      handleOnViewColumnsChange(columnName, action, tableName);
    },
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      const handleKeyDown = (event) => {
        if (event.key === "Enter") {
          handleSearch(event.target.value);
        }
      };

      return (
        <TextField
          variant="standard"
          placeholder="Search"
          defaultValue={searchText}
          onKeyDown={handleKeyDown}
          onBlur={hideSearch}
          fullWidth
          autoFocus
        />
      );
    },
    onTableChange: (action, tableState) => {
      if (aiMode && action !== "changeRowsPerPage") {
        return;
      }

      switch (action) {
        case "changeRowsPerPage":
          handleChangeRowsPerPage(tableName, tableState.rowsPerPage);
          if (!aiMode) {
            handleSearchCandidats(1, parameters, tableState.rowsPerPage);
          }
          break;
        case "changePage":
          handleSearchCandidats(tableState.page + 1, {
            ...parameters,
            column: tableState.sortOrder.name,
            sort: tableState.sortOrder.direction,
          });
          break;
        case "sort":
          handleSearchCandidats(tableState.page + 1, {
            ...parameters,
            column: tableState.sortOrder.name,
            sort: tableState.sortOrder.direction,
          });
          break;
        case "search":
          const searchText = tableState.searchText || "";
          debouncedSearch(searchText, tableState, parameters, handleSearchCandidats);
          break;
        default:
      }
    },
    selectableRows: "multiple",
    draggableColumns: {
      enabled: true,
    },
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    customToolbarSelect: (selectedRows) => (
      <CustomToolbarSelect selectedminRows={selectedRows} />
    ),
    onRowSelectionChange: (rowsSelected, allRowsSelected) => {
      const candidatIds = allRowsSelected
          .map((element) => candidats[element.index]?.id)
          .filter(Boolean);
      dispatch(SetSelectedCandidatBeAddToSelection(candidatIds));
    },
  };

  const handleCloseDialog = () => {
    if (loadToDelete) {
      return;
    }
    setOpenDialogDelete(false);
  };

  const dialogDeleteProps = {
    handleClose: handleCloseDialog,
    handleOpen: openDialogDelete,
    loading: loadToDelete,
    title: "Supprimer le candidat",
  };

  const viewCandidat = (candidatId, tabIndex) => {
    let candidatsIds = [];

    candidats.forEach((candidat) => {
      candidatsIds.push(candidat.id);
    });

    history.push({
      pathname: `/candidats/${candidatId}/view`,
      state: {
        tabIndex: tabIndex,
        candidatsInList: candidatsIds,
        candidatIndex: candidatsIds.indexOf(candidatId),
        numbersTotalOfSelections: candidats.length
      },
    });
  };

  const columns = [
    {
      name: "ia_score",
      label: "SCORE IA",
      options: {
        display: aiMode,
        filter: false,
        sort: true,
        setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "center" } }),
        setCellProps: () => ({ style: { textAlign: "center" } }),
        customBodyRender: (value) => {
          if (value == null) return "-";
          const score = parseFloat(value);
          const color = score >= 7 ? "#4caf50" : score >= 4 ? "#ff9800" : "#f44336";
          return (
            <Box style={{ color, fontWeight: "bold", textAlign: "center" }}>
              {score.toFixed(1)}
            </Box>
          );
        },
      },
    },
    {
      name: "updatedAt",
      label: "DATE MAJ",
      options: {
        display: displayColumn("updatedAt", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return <> {value != null ? moment(value).format("DD/MM/yyyy") : "-"}</>;
        },
      },
    },
    {
      name: "nom",
      label: "NOM",
      options: {
        display: displayColumn("nom", tableName),
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "150px",
          },
        }),
                customBodyRender: (value, tableMeta, updateValue) => {
                  const row = getRowData(tableMeta, columns);
          return (
            <Box
              data-toggle="tooltip"
              title={value}
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "130px",
              }}
            >
              {!(isSmall || isMediumMode) && (
                <IconButton
                  onClick={() =>
                    dispatch(
                      displaySwipeableDrawerSummaryCandidat({
                        show: true,
                        id: row.id,
                      })
                    )
                  }
                  data-toggle="tooltip"
                  title="Voir resumé"
                >
                  <RemoveRedEye size={"15px"} />
                </IconButton>
              )}
              <Link
                to={{ pathname: `/candidats/${row.id}/view` }}
                onClick={(e) => {
                  e.preventDefault()
                  viewCandidat(row.id, 0)
                }}
              >
                {value}
              </Link>
            </Box>
          );
        },
      },
    },
    {
      name: "prenom",
      label: "PRENOM",
      options: {
        display: displayColumn("prenom", tableName),
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textTransform: "capitalize",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "130px",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "150px",
                }}
              >
                <Link
                  to={{ pathname: `/candidats/${row.id}/view` }}
                  onClick={(e) => {
                    e.preventDefault()
                    viewCandidat(row.id, 0)
                  }}
                >
                  {value}
                </Link>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "numCandidat",
      label: "N°",
      options: {
        display: displayColumn("numCandidat", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
        customBodyRender: (value, tableMeta) => {
          if (aiMode) return value ?? "-";
          const rowData = getRowData(tableMeta, columns);
          const candidatName = `${rowData.prenom} ${rowData.nom}`;
          const uploadedFiles = rowData.uploadedFiles || [];
          return (
            <ShowAddCvCandidat
              {...{ snackbarShowMessage, files: uploadedFiles, fileName: candidatName }}
            >
              {value}
            </ShowAddCvCandidat>
          );
        },
      },
    },
    {
      name: "id",
      label: "N°",
      options: {
        display: false,
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "100px",
          },
        }),
        customBodyRender: (value) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value}>
                {value.substring(0, 30).replace(/\D/g, "").substring(1, 7)}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "societe",
      label: "SOCIETE",
      options: {
        display: displayColumn("societe", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { justifyContent: "center" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                }}
              >
                <Link
                  to={{ pathname: `/societe/${row.societeId}/view` }}
                >
                  {value}
                </Link>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "societeId",
      label: "N° societe",
      options: {
        display: false,
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { justifyContent: "center" } }),
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "100px",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                }}
              >
                {value}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "telephone",
      label: "MOBILE",
      options: {
        display: displayColumn("telephone", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { justifyContent: "center" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "150px",
                }}
              >
                {value}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "localisation",
      label: "LOCALISATION",
      options: {
        display: displayColumn("localisation", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { justifyContent: "center" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "150px",
                }}
              >
                {value}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "mobilite",
      label: "MOBILITE",
      options: {
        display: displayColumn("mobilite", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { justifyContent: "center" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "150px",
                }}
              >
                {value}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "email",
      label: "EMAIL",
      options: {
        display: displayColumn("email", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { justifyContent: "center" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  maxWidth: "250px", // Adjusted width
                }}
              >
                {value}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "fonction",
      label: "FONCTION",
      options: {
        display: displayColumn("fonction", tableName),
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { justifyContent: "center" } }),
        setCellProps: () => ({ style: { textTransform: "capitalize" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{

                  width: "350px",
                }}
              >
                {value}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "dateDebutExperience",
      label: "XP",
      options: {
        display: displayColumn("dateDebutExperience", tableName),
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "80px",
            textAlign: "center",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
        customBodyRender: (value, tableMeta) => {
          const yearsExp = candidats[tableMeta.rowIndex]?.years_of_experience;
          const xpDisplay = value?.date
            ? getSenioriteFromDate(value.date)
            : yearsExp != null
            ? `${yearsExp} ans`
            : null;
          return (
            <>
              <div
                data-toggle="tooltip"
                title={xpDisplay}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {xpDisplay}
              </div>
            </>
          );
        },
      },
    },
    {
      name: "linkedin",
      label: "LKD",
      options: {
        display: displayColumn("linkedin", tableName),
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "100px",
          },
        }),
        setCellHeaderProps: () => ({ style: { text: "center" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  display: "flex",
                  width: "55%",
                  justifyContent: "center",
                }}
              >
                <a href={value} target="_blank" rel="noreferrer">
                  <LinkedIn />
                </a>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "consultant",
      label: "CONSULTANT",
      options: {
        display: displayColumn("consultant", tableName),
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "100px",
            textTransform: "capitalize",
          },
        }),
        customBodyRender: (value) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "150px",
                }}
              >
                {value ? value : "-"}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "selections",
      label: "VIVIERS",
      options: {
        display: displayColumn("selections", tableName),
        filter: true,
        sort: true,
        sortCompare: (order) => (a, b) => {
          const lengthA = (a.data && a.data.length) || 0;
          const lengthB = (b.data && b.data.length) || 0;
          return (lengthA - lengthB) * (order === 'asc' ? 1 : -1);
        },
        customHeadLabelRender: (columnMeta) => {
          return (
            <Chip
              avatar={
                <Search
                  alt={columnMeta.label}
                  src="/static/images/avatar/1.jpg"
                />
              }
              label={columnMeta.label}
              variant="outlined"
            />
          );
        },
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const safeValue = Array.isArray(value) ? value : [];
          const row = getRowData(tableMeta, columns);
          return safeValue.length <= 0 ? (
            <div
              aria-haspopup="true"
              data-toggle="tooltip"
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "80%",
                display: "flex",
                justifyContent: "center",
              }}
              onMouseEnter={(event) =>
                handlePopoverOpen(event, tableMeta.rowIndex)
              }
              onMouseLeave={() => handlePopoverClose(tableMeta.rowIndex)}
            >
              {safeValue.length}
            </div>
          ) : (
            <>
              <Link
                to={{
                  pathname: `/candidats/${row.id}/view`,
                }}
                onClick={(e) => {
                  e.preventDefault()
                  viewCandidat(row.id, 3)
                }}
                aria-haspopup="true"
                data-toggle="tooltip"
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
                onMouseEnter={(event) =>
                  handlePopoverOpen(event, tableMeta.rowIndex)
                }
                onMouseLeave={() => handlePopoverClose(tableMeta.rowIndex)}
              >
                {safeValue.length}
                <PopoverComponent
                  selections={safeValue}
                  candidat={candidats[tableMeta.rowIndex]}
                />
              </Link>
            </>
          );
        },
      },
    },
    {
      name: "",
      label: "ACTION",
      options: {
        filter: false,
        sort: false,
        display: getUserData()?.role.includes("ROLE_ADMIN"),
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "100px",
            textTransform: "capitalize",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <IconButton
              data-toggle="tooltip"
              title="Supprimer"
              aria-label="Supprimer"
              onClick={() =>
                handleOpenDialog({
                  id: row.id,
                  fullName: `${row.nom}  ${row.prenom}`,
                })
              }
              style={{ color: "#EF6262" }}
            >
              <Delete />
            </IconButton>
          );
        },
      },
    },
    {
      name: "uploadedFiles",
      label: "Files",
      options: {
        display: displayColumn("uploadedFiles", tableName),
        filter: false,
        viewColumns: false,
        customBodyRender: () => null
      },
    },
  ];

  const data = candidats.map((item) => ({
    ...item,
    updatedAt: item.updatedAt?.date ? moment(item.updatedAt?.date).toDate().getTime() : null,
  }));

  return (
    <>
      <div className="candidatTableWrapper" style={{ flex: 1, minHeight: aiMode && aiRows?.isLoading ? 400 : 0, display: "flex", flexDirection: "column", position: "relative" }}>
      {aiMode && aiRows?.isLoading && (
        <Box style={{
          position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          background: "#fff", zIndex: 10,
        }}>
          <CircularProgress />
        </Box>
      )}
      <MUIDataTable
        title="Candidats"
        data={data}
        columns={columns}
        options={options}
      />
    </div>
      <DialogDeleteCustom
        {...dialogDeleteProps}
        handleDelete={() => handleDeleteCandidat(candidatSelectedToDelete?.id)}
        label={`Voulez - vous vraiment supprimer le candidat ${candidatSelectedToDelete?.fullName} ?`}
      />
    </>
  );
};

export default withSnackbar(CandidatTable);
